<template>
    <div>
        <!-- begin breadcrumb -->
        <ol class="breadcrumb float-xl-right">
            <li class="breadcrumb-item active"><a href="javascript:;">Detalle Entrega Equipo </a></li>
        </ol>
        <!-- end breadcrumb -->
        <!-- begin page-header -->
        <h1 class="page-header">
            <router-link  class="btn btn-warning " to="/entregas/equipo" > <i class="fa fa-arrow-left"></i> Regresar</router-link>
 &nbsp;
            Detalle Entrega Equipo IMEI: <b>{{this.$route.params.imei}}</b></h1>
        <!-- end page-header -->
        <!-- begin panel -->
        <!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
        <!-- end panel -->
        <!-- begin card -->
        <div class="card  border-0 ">
            <div class="card-body">
                <button type="button" class="btn btn-primary " @click="confirmar()"> <i class="fa fa-save"></i> Guardar
                    Datos </button>
            
            </div>
        </div>
        <!-- begin row -->
        <div class="row animated fadeIn">
            <!-- begin col-12 -->
            <div class="col-xl-12">
                <br>
                <table class="table align-middle">
                    <thead class="bg bg-white">
                        <tr>
                            <th class="h4">APELLIDOS Y NOMBRES DEL VENDEDOR</th>
                            <th class="text-center h4">MODELO</th>
                            <th class="text-center h4">IMEI</th>
                            <th class="text-center h4">ESTADO</th>
                            <th class="text-center h4">TIPO COMISION</th>
                            <th class="text-center h4">MONTO COMISION</th>
                            <th class="text-center h4">FECHA VENTA</th>
                            <th class="text-center h4">FECHA REGISTRO</th>
                        </tr>
                    </thead>
                    <br>
                    <tbody>
                        <tr v-for="c in equipo" :key="c.Id">
                           
                            <th class=" h4">{{c.vendedor}} ---- <small><i> {{c.tipo_vendedor ==1 ? 'FFVV' : c.tipo_vendedor ==2 ?  'PDV' :  'SIN DEFINIR'}} </i></small></th>
                            <th class="text-center h4">{{c.modelo}}</th>
                            <th class="text-center h4">{{c.imei}}</th>
                              <td>
                                <select :disabled="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00' "
                                    v-model="c.estado" class="form-control">
                                    <option value="0">ANULADO</option>
                                    <option value="1">VENDIDO - ACTIVADO</option>
                                    <option value="2">NUEVO</option>
                                </select>
                            </td>
                            <td>
                                <select v-if="c.estado>0" :key="c.Id" :id="c.Id"  :disabled="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00'" v-validate="'required|excluded:0'" :data-vv-name="'comision-del-chip-'+c.chip"
                                    class="form-control font-weight-bold" v-model="c.tipo_comision">
                                    <option value="0">Seleccione tipo de comisión...</option>
                                    <option v-for="d in $store.state.dataComisionEquipo" :key="d.Id" :value="d.Id">
                                          {{c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00' ? d.comision:d.comision+' - '+d.monto}}</option>
                                </select>
                            
                                <error :attribute_name="'comision-del-chip-'+c.chip" :errors_form="errors" />
                            </td>
                            <th class="h4 text-center">
                               S/. {{c.monto}}
                            </th>
                            <th
                                :class="c.fecha_venta!=null && c.fecha_venta!='0000-00-00 00:00:00'  ?   'text-center bg-warning rounded' : c.estado=='0' ? 'text-center bg-primary rounded' : 'text-center'">
                                {{c.fecha_venta == null ? '----':c.fecha_venta=='0000-00-00 00:00:00' ? '----':c.fecha_venta }}
                            </th>
                            <th class="text-center">{{ c.fecha_registro}}</th>
                        </tr>
                    </tbody>
                </table>
                <procesando v-if="proceso" />
            </div>
            <!-- end col-12 -->
        </div>
        <!-- end row -->
    </div>
</template>
<script>
    import comision from '../components/compartidos/SelectComision'
    import registros from '../components/compartidos/Registros'
    import procesando from '../components/compartidos/Procesando'
    import axios from 'axios'
    import error from '../components/compartidos/Error'
    export default {
        name: "EntregaDetalleChip",
        components: {
            comision,
            registros,
            procesando,
            error
        },
        beforeMount() {
            this.cargarDetalle();
        },
        data() {
            return {
                prueba: "000",
                proceso: false,
                nuevo: true,
                entregaChip: null,
                nuevoEntregaChip: 0,
                counter: 0,
                forms: [],
                detalles: [],
                totalRecords: 0,
                equipo: [],
                chip: {
                    chip: '',
                    fecha_registro: '',
                    dni_admin: '',
                    dni_vendedor: '',
                    vendedor: '',
                    tipo_comision: '',
                    fecha_venta: '',
                    monto: '',
                    estado: '0'
                }

            }
        },
        methods: {
            alert(a) {
                alert(a);
            },
            cargarDetalle() {
                this.proceso = true;
                axios.post(this.URL_BASE() + "detalle_ventas_equipo/read/" + this.$route.params.imei).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                    if (respuesta.data.msg == 'exito') {
                        // this.equipo=[...respuesta.data.data]
                        respuesta.data.data.forEach(element => {
                            this.chip = {
                                ...element
                            }
                            this.equipo.push(this.chip);
                        });
                    }
                    this.proceso = false;
                }).catch((error)=> {
                    console.log("er store" + error);
                });
            },
            guardar() {
                this.proceso = true;

                axios.put(this.URL_BASE() + "detalle_ventas_equipo/update/", this.equipo).then(respuesta => {
                    //   console.log(respuesta.data.msg)
                    if (respuesta.data.msg == 'exito' || respuesta.data.msg == 'vacio') {
                        this.exito("Guardado correctamente");
                        setTimeout(() => {
                              this.$router.push('/entregas/equipo');
                        }, 500);
                    }
                    this.proceso = false;
                }).catch((error)=> {
                    console.log("er store" + error);
                });
            },
            confirmar() {

                this.$validator.validateAll().then((result) => {
                    if (result) {
                        // let a = await this.confirmar();
                        this.$swal({
                            title: '¿Está seguro?',
                            text: 'Se guardará todos los datos',
                            type: 'warning',
                            showCancelButton: true,
                            buttonsStyling: false,
                            confirmButtonText: 'Confirmar',
                            cancelButtonText: 'Cancelar',
                            confirmButtonClass: 'btn m-r-5 btn-warning',
                            cancelButtonClass: 'btn btn-default',
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.value) {
                                this.guardar();
                                // this.$swal('Proceso confirmado', '', 'success')
                                return true;
                            } else if (result.dismiss) {
                                return false;
                                // Swal.fire('Changes are not saved', '', 'info')
                            }
                        })
                    } else {
                        console.log('sd');
                    }
                });

            },

        },
    }
</script>